<div class="mob-beneficios mob-box-container">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="mob-title-3 text-red text-center mb-40">
          {{ VO?.offer_title }}
        </div>
        <swiper [config]="swiperConfig">
          <ng-template swiperSlide>
            <mob-offer-item
              *ngIf="VO?.offer_title_1"
              [icone]="VO?.offer_icon_1"
              [offer_title]="VO?.offer_title_1"
              [offer_description]="VO?.offer_description_1"
            >
            </mob-offer-item>
          </ng-template>
          <ng-template swiperSlide>
            <mob-offer-item
              *ngIf="VO?.offer_title_2"
              [icone]="VO?.offer_icon_2"
              [offer_title]="VO?.offer_title_2"
              [offer_description]="VO?.offer_description_2"
            >
            </mob-offer-item>
          </ng-template>
        </swiper>
      </div>
    </div>
  </div>
</div>
